module.exports = __webpack_public_path__ + "static/media/landing-bg.df8fd3ef.jpg";